export default function (text: string | null | undefined) {
    return text ? text.replace(/<\/?.+?>/ig, '') : '';
}
